<template>
    <div>
        <div v-if="info" class="alert alert-success">
            {{info}}
        </div>
        <div v-if="error" class="alert alert-danger">
            {{error}}
        </div>
    </div>
</template>

<script>
    export default {
        name: "feedback",
        props: ["info", "error"]
    }
</script>

<style scoped>

</style>
